<template>
  <Container type="card-full" class="confirmFormContainer">
    <div slot="header">
      <el-button type="primary" @click="savePsu" v-if="!disable && +project.projectcuserid === +this.$store.getters.loginUser.userid" :loading="loading">确认</el-button>
      <!-- <el-button type="primary"  @click="viewWinningBid" v-if="disable" :loading="loading">查看成交通知书</el-button> -->
      <vxe-button type="primary" v-for="(btn) in this.$route.params.innerbtn" :key="btn.btncode" icon='el-icon-connection' status="">{{btn.btnname}}</vxe-button>
      <span class="status" v-if="disable">成交已确认</span>
    </div>
    <div class="container">
      <div>
        <header-com :project='project'></header-com>
      </div>
      <div style="margin:10px;" v-if="disable">
        <el-button type='primary' @click='projectResultNotice' v-if="+this.project.projectstatus <= 40">发布成交公告</el-button>
        <el-button type='primary' @click='toCJGG' v-else>查看成交公告</el-button>
      </div>
      <vggrid ref="xGrid" :list="list" tableheight="700" flexname=""
              :cols="cols"
              :showfooter="false"
              :showPage="false" :resizable="true"
              @cellClick="cellClick" @cellDblClick="viewProject" :canbeEdit="true">
      </vggrid>
    </div>
    <el-dialog :close-on-click-modal="false"  @close="dialogClose" :title="dialogName" :visible.sync="dialogVisible" width="800px"
               :modal-append-to-body="false">
      <pbid-confirm-fee-amt-form @close="dialogClose" :projectid="project.projectid" :list="newPsuList"></pbid-confirm-fee-amt-form>
    </el-dialog>
  </Container>
</template>
<script>
  import request from '@/utils/request'
  import utils from '../../assets/js/utils'
  import vggrid from '../common/vggrid'
  import PbidConfirmFeeAmtForm from './pbidConfirmFeeAmtForm'
  import headerCom from '../component/headerCom'
  import dayjs from 'dayjs'
  /* eslint-disable */
  export default {
    name: 'psuBatchForm',
    data () {
      return {
        dialogVisible: false,
        list: [],
        psu:{},
        newPsuList: [],
        comList:[],
        project: {},
        cols: [],
        loading: true,
        formLabelWidth: '100px',
        disable: false
      }
    },
    created () {
      this.init()
      this.getModel()
      this.getPsuList()
    },
    activated() {
    },
    mounted () {
    },
    computed:{
      dialogName () {
        if (+this.$store.getters.loginUser.comtype === 1) {
          return '服务费确认'
        } else if (+this.$store.getters.loginUser.comtype === 2) {
          return '确认成交'
        }
      },
    },
    components: {vggrid, PbidConfirmFeeAmtForm,headerCom},
    methods: {
      dialogClose () {
        this.getPsuList()
        this.dialogVisible = false
      },
      async init() {
        this.list = []
        this.cols = []
        this.comList = []
        this.project = {}
        this.disable = false
      },
      async getModel () {
        this.cols =  [
          { field: 'comfullname', fieldtype: 'C', title: '供应商',calculExpr:'',addNewRowFlg: false},
          { field: 'username', fieldtype: 'C', title: '经办人',calculExpr:'',addNewRowFlg: false},
          // { field: 'psuamt1', fieldtype: 'F', title: '最终报价',calculExpr:'',addNewRowFlg: false},
          { field: 'psuoffertime', fieldtype: 'F', title: '报价时间',calculExpr:'',addNewRowFlg: false},
          // {field: 'psuoffertime', fieldtype: 'C', title: '报价时间', calculExpr: '', addNewRowFlg: false},
          { field: 'psuas', fieldtype: 'F', title: '得分',calculExpr:'',addNewRowFlg: false},
          { field: 'psubidorder',fieldtype: 'C', title: '排名',calculExpr:'', width: 80 },
          { type: 'checkbox',fieldtype: 'I', title: '成交',calculExpr:'', width: 80 }
        ],
        this.loading = true
        this.btnLoading = true
        let res = await request({
          method: 'get',
          url: '/xmgl/project/findProjectById',
          params: {projectid: this.$route.params.form.projectid}
        })
        this.project = res
          if(+this.project.projectquotationmode === 1){
            this.cols.splice(2,0,{field: 'psuamt1', title:'最终报价', calculExpr: '', addNewRowFlg: false})
          }else if(+this.project.projectquotationmode === 2){
            this.cols.splice(2,0,{field: 'psupricerate', title:'上浮率%', calculExpr: '', addNewRowFlg: false})
          }else if(+this.project.projectquotationmode === 3){
            this.cols.splice(2,0,{field: 'psupricerate', title:'下浮率%', calculExpr: '', addNewRowFlg: false})
          }else if(+this.project.projectquotationmode === 4){
            this.cols.splice(2,0,{field: 'psupricerate', title:'折扣率%', calculExpr: '', addNewRowFlg: false})
          }
      },
      async savePsu () {
        let selectRecords = this.$refs.xGrid.$refs.xGrid.getSelectRecords()
        if (!selectRecords.length) {
          this.$message.warning('请选择成交供应商！')
          return
        }
        this.dialogVisible = true
        this.list = this.list.map(v => {
          v.psubidflg = 0
          v.psufeeamt = v.prschangefee
          v.psuchargeflg = v.prschangeflg
          v.psuoffertime = dayjs(v.psuoffertime).format('YYYY-MM-DD HH:mm:ss SSS')
          selectRecords.forEach(t => {
            if (+t.psuid === +v.psuid) {
              v.psubidflg = 1
            }
          })
          return v
        })
        let model = {
          psuList: this.list.filter(v => +v.psubidflg===1),
          projectid: this.project.projectid,
          pmchargefeetype: this.project.pmchargefeetype,
          projectlimitamt: this.project.projectlimitamt,
          userid: this.$store.getters.loginUser.userid
        }
       let psulist = await request({
          url: '/xmgl/project/saveComputeFeeAmt',
          method: "post",
          data: model
        })
        // psulist.map(e=>{
        //   e.psuoffertime = dayjs(e.psuoffertime).format('YYYY-MM-DD HH:mm:ss SSS')
        //   console.log('-------e---------',e);
        // })
        this.newPsuList = psulist
        // let data = await request({
        //   url: '/xmgl/project/savePbidConfirm',
        //   method: "post",
        //   data: model
        // })
        // if (data.issuccess === 1) {
        //   this.$message.success('确认成交成功！')
        //   this.close()
        //   this.disable = true
        // } else {
        //   this.$message.success('确认成交失败！')
        // }
      },
      async cellClick (row) {
        this.psu = row.row
      },
      async toCJGG(){
        let {href} = this.$router.resolve({name: 'pjnoticebypid', query: {projectid: this.project.projectid,pjnoticetype:60}})
        window.open(href, '_blank')
      },
      async projectResultNotice(){
        this.$router.push({name: 'pjnoticeIndex', params: {projectid:this.project.projectid,type: 1}})
      },
      async viewWinningBid(row, type){
          this.psu = row
          if(+this.psu.psubidflg != 1){
            this.$message.warning('该单位未成交！')
            return
          }
          if (type && type === 'cg') {
            let {href} = this.$router.resolve({name: 'cgBiddingNotice', query: {psuid: this.psu.psuid,projectid: this.project.projectid}})
            window.open(href, '_blank')
            return
          }
          // this.$router.push({name: 'projectBiddingNotice', params: {psuid: this.psu.psuid,projectid: this.project.projectid}})
          let {href} = this.$router.resolve({name: 'pjBiddingNotice', query: {psuid: this.psu.psuid,projectid: this.project.projectid}})
          window.open(href, '_blank')
      },
      async toEditWinningBid(row){
        this.psu = row
        this.$router.push({name: 'editWinningBid', params: {psuid: this.psu.psuid,projectid:this.project.projectid,type: 1}})
      },
      async setRadioRow() {
        let Index = this.list.findIndex(item => item.psubidflg === 1)
        if (Index!==-1) {
          this.disable = true
          // this.$refs.xGrid.$refs.xGrid.setRadioRow(this.list[Index])
          if(this.cols.slice(-1)[0].title != '操作'){
            this.cols.push({ title: '操作', width: 240, showOverflow: true,
              slots: {
                default: ({row}) => {
                  if(+row.psubidflg === 1 && +row.psubcnflg === 1){
                    return [<vxe-button type="primary" onClick={this.toEditWinningBid.bind(this,row)}>编写通知书</vxe-button>]
                  }
                  else if(+row.psubidflg === 1 && +row.psubcnflg === 2){
                    return [<vxe-button type="primary" onClick={this.viewWinningBid.bind(this,row)}>通知书(供)</vxe-button>, <vxe-button type="primary" onClick={this.viewWinningBid.bind(this,row, "cg")}>通知书(采)</vxe-button>]
                  }
                }}
            })

          }
        }
      },
      async getPsuList () {
        this.loading = true
        let res = await request({
          method: 'get',
          url: '/xmgl/project/getPsuListByProjectId',
          params: {projectid: this.$route.params.form.projectid, yxflag: 1}
        })
        this.list = res
        this.setRadioRow()
        this.list.forEach(key => {
          key.psuamt1 = utils.comdify(key.psuamt);
          key.username = key.username + " " + key.usermobile
          key.psuoffertime = dayjs(key.psuoffertime).format('YYYY-MM-DD HH:mm:ss SSS')
        });
        this.loading = false
      },
      async viewProject(row) {
        this.psu = row.row
        this.$router.push({name: 'psuBmForm', params: {psuid: this.psu.psuid}})
      },
      close () {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: 'pbidConfirmIndex'})
      }
    },
    filters: {
    }
  }
</script>

<style lang="scss">
  .confirmFormContainer .dd-card-full__body {
    top: 65px !important;
  }
  .status {
    color: red;
    padding-left: 10px;
  }

</style>
